import api from '../../../../api/client';

export const DATE_PRESET_OPTIONS = [
  { value: 'All', label: 'All Periods' },
  { value: 'Current Financial Year', label: 'Current Financial Year (2026-27)' },
  { value: 'This Month', label: 'This Month' },
  { value: 'Last Month', label: 'Last Month' },
  { value: 'Today', label: 'Today' },
  { value: 'Custom', label: 'Custom Range' },
];

export const STATUS_OPTIONS = [
  { value: 'Active', label: 'Active' },
  { value: 'Inactive', label: 'Inactive' },
  { value: 'All', label: 'All' },
];

export const holidayMasterApi = {
  getAll: async (filters = {}) => {
    const params = {};
    if (filters.name && filters.name.trim()) {
      params.search = filters.name.trim();
      params.search_field = 'Name';
    }
    if (filters.group && filters.group !== 'All' && filters.group !== 'Select') {
      params.emp_group = filters.group;
    }
    if (filters.fromDate) {
      params.from_date = filters.fromDate;
    }
    if (filters.toDate) {
      params.to_date = filters.toDate;
    }
    if (filters.status) {
      params.status_filter = filters.status;
    }
    if (filters.page) {
      params.page = filters.page;
    }
    if (filters.pageSize) {
      params.page_size = filters.pageSize;
    }

    const response = await api.get('/payroll/holiday-master', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/payroll/holiday-master/${id}`);
    return response.data;
  },

  create: async (data) => {
    let csv = '';
    if (typeof data.group_id_csv === 'string') {
      csv = data.group_id_csv.trim();
    } else if (Array.isArray(data.groups)) {
      csv = data.groups.map(Number).filter((n) => !isNaN(n) && n > 0).join(',');
    }
    const payload = {
      name: data.name,
      hDate: data.date || data.hDate,
      branch_id: data.branch_id || 0,
      group_id_csv: csv,
    };
    const response = await api.post('/payroll/holiday-master', payload);
    return response.data;
  },

  update: async (id, data) => {
    let csv = '';
    if (typeof data.group_id_csv === 'string') {
      csv = data.group_id_csv.trim();
    } else if (Array.isArray(data.groups)) {
      csv = data.groups.map(Number).filter((n) => !isNaN(n) && n > 0).join(',');
    }
    const payload = {
      name: data.name,
      hDate: data.date || data.hDate,
      branch_id: data.branch_id || 0,
      group_id_csv: csv,
    };
    const response = await api.put(`/payroll/holiday-master/${id}`, payload);
    return response.data;
  },

  archive: async (id) => {
    const response = await api.patch(`/payroll/holiday-master/${id}/archive`);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/payroll/holiday-master/${id}`);
    return response.data;
  },

  getEmployeeGroups: async () => {
    try {
      const response = await api.get('/payroll/holiday-master/groups');
      return response.data || [];
    } catch {
      return [];
    }
  },
};
